// @ts-nocheck
import React, { useCallback } from 'react';
import { Button, Intent } from '@blueprintjs/core';
import { compose } from '@/utils';
import { Icon, FormattedMessage as T } from '@/components';
import withDialogActions from '@/containers/Dialog/withDialogActions';

function CarriersActions({ openDialog }) {
  const handleClickNewCarrier = useCallback(() => {
    openDialog('carrier-form');
  }, [openDialog]);

  return (
    <div className="carriers-actions">
      <Button
        icon={<Icon icon="plus" iconSize={12} />}
        onClick={handleClickNewCarrier}
        intent={Intent.PRIMARY}
        style={{ backgroundColor: '#2196F3' }}
      >
        <T id={'new_carrier'} />
      </Button>
    </div>
  );
}

export default compose(withDialogActions)(CarriersActions);